var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgValueRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_95267)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.54084 8.02511C4.54084 6.09212 6.10785 4.52511 8.04085 4.52511L13.9571 4.52514C14.2665 4.52511 14.5633 4.64806 14.7821 4.86683L23.1732 13.258C23.6288 13.7136 23.6288 14.4522 23.1732 14.9079L14.9236 23.1574C14.468 23.6131 13.7293 23.6131 13.2737 23.1574L4.88257 14.7663C4.66379 14.5476 4.54084 14.2508 4.54087 13.9414L4.54084 8.02511ZM8.04087 2.1918C4.8192 2.19179 2.20752 4.80347 2.20753 8.02514L2.20751 13.9414C2.20752 14.8696 2.57627 15.7599 3.23265 16.4162L11.6238 24.8074C12.9906 26.1742 15.2067 26.1742 16.5735 24.8074L24.8231 16.5578C26.1899 15.1909 26.1899 12.9749 24.8231 11.608L16.432 3.21692C15.7756 2.56054 14.8854 2.19179 13.9571 2.19177L8.04087 2.1918ZM9.14889 9.13316C9.60451 8.67754 9.60452 7.93887 9.14889 7.48324C8.69326 7.02761 7.95459 7.02763 7.49898 7.48324C7.04336 7.93886 7.04335 8.67753 7.49898 9.13316C7.95461 9.58879 8.69328 9.58878 9.14889 9.13316Z",
    fill: "#003D6A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_95267"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValueRating);
export default __webpack_public_path__ + "static/media/value-rating.862c722ed97fe84fc3d8d565604bc17f.svg";
export { ForwardRef as ReactComponent };